import React from "react";
import classNames from "classnames";

import classes from "../../style.module.scss";
import { useRemoteConfig } from "core/hooks/use-remote-config";

interface Props {
  textLineThrough: string;
  trialPrice: string;
  className?: string;
}
const TrialPrice: React.FC<Props> = ({
  textLineThrough,
  trialPrice,
  className,
}) => {
  const { newPaymentModal } = useRemoteConfig();
  return (
    <p className={classNames(classes.aboutItemText, className)}>
      <span className={newPaymentModal ? classes.lineThroughNew : classes.lineThrough}>{textLineThrough}</span>
      <span className={newPaymentModal && classes.discountNew}> {trialPrice}</span>
    </p>
  );
};

export default TrialPrice;
